import React from "react";
import { groups } from "./groupsData";
import styled from "styled-components";
import { FaEllipsisH, FaStar, FaPlus } from "react-icons/fa";

const GroupsGrid = () => {
    return (
        <Grid>
            {groups.map((group, index) => (
                <Card key={index}>
                    <div className="header">
                        <StatusBadge status={group.status}>
                            {group.status}
                        </StatusBadge>
                        <FaEllipsisH />
                    </div>
                    <h2>{group.name}</h2>
                    <h4>{group.specialty}</h4>
                    <p className="desc">{group.description}</p>

                    <Info>
                        <span>
                            Members: <strong>{group.members}</strong>
                        </span>
                        <span>
                            Videos: <strong>{group.videos}</strong>
                        </span>
                        <span>
                            Views:{" "}
                            <strong>{group.views.toLocaleString()}</strong>
                        </span>
                        <span>
                            Rating:{" "}
                            <strong>
                                {group.rating} <FaStar color="#facc15" />
                            </strong>
                        </span>
                    </Info>

                    <Manage>Manage Group</Manage>
                </Card>
            ))}

            <AddCard>
                <div className="plus">
                    <FaPlus />
                </div>
                <h3>Add New Group</h3>
                <p>Create a new specialty group for physicians</p>
                <button>
                    <FaPlus /> Add Group
                </button>
            </AddCard>
        </Grid>
    );
};

export default GroupsGrid;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    padding: 20px;
`;

const Card = styled.div`
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    h2 {
        font-size: 1.25rem;
        font-weight: 600;
        margin: 10px 0 4px;
        color: var(--primary-text-color);
    }

    h4 {
        color: #6b7280;
        font-size: 0.95rem;
        margin-bottom: 8px;
        color: var(--secondary-text-color);
    }

    .desc {
        font-size: 0.85rem;
        color: #374151;
        margin-bottom: 12px;
        color: var(--secondary-text-color);
    }
`;

const StatusBadge = styled.span`
    background-color: ${({ status }) =>
        status === "Active" ? "#a855f7" : "inherit"};
    color: ${({ status }) =>
        status === "Active" ? "#fff" : "var(--primary-text-color)"};
    /* color: var(--primary-text-color); */
    font-size: 0.75rem;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 999px;
    border: 1px solid var(--border-color);
`;

const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.9rem;

    span {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--secondary-text-color);

        strong {
            font-weight: 600;
            margin-left: 5px;
            color: var(--primary-text-color);
        }

        svg {
            margin-left: 4px;
            font-size: 0.85rem;
        }
    }

    margin-bottom: 12px;
`;

const Manage = styled.span`
    color: var(--primary-text-color);

    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;
    margin-top: auto;
`;

const AddCard = styled.div`
    border: 2px dashed var(--border-color);
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .plus {
        background: var(--secondary-bg);
        width: 40px;
        height: 40px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        font-size: 1.2rem;
        color: var(--primary-text-color);
    }

    h3 {
        margin-bottom: 5px;
        font-size: 1rem;
        font-weight: 600;
        color: var(--primary-text-color);
    }

    p {
        font-size: 0.85rem;
        color: var(--secondary-text-color);
        margin-bottom: 15px;
    }

    button {
        display: flex;
        align-items: center;
        gap: 6px;
        background-color: #8b5cf6;
        color: #fff;
        padding: 8px 14px;
        font-size: 0.85rem;
        border-radius: 6px;
        border: none;
        cursor: pointer;
    }
`;
